module.exports = __webpack_public_path__ + "static/media/bruno_gomes_coelho.0418036b.png";